import AppLayout from '../../../components/AppLayout';
import { S } from '../../regureStyles';
import useCarrierDetailFunctions from './useCarrierDetailFunctions';

import Header from './Header';
import OverviewTab from './OverviewTab';
import BordereauxTab from './BordereauxTab';
import ConfigTab from './ConfigTab';

const CarrierDetail = ({ carrier: initCarrier, onBack, onUpdate }) => {
  const {
    carrier,
    activeTab,
    setActiveTab,
    bordereaux,
    loadingB,
    generating,
    genForm,
    setGenForm,
    showGenForm,
    setShowGenForm,
    config,
    setConfig,
    savingCfg,
    cfgSaved,
    sending,
    handleGenerate,
    handleDownload,
    handleSend,
    handleSaveConfig,
    TABS,
  } = useCarrierDetailFunctions({ initCarrier, onUpdate });

  return (
    <AppLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* ── Header ──────────────────────────────────────── */}
        <Header onBack={onBack} carrier={carrier} />

        {/* ── Tabs ────────────────────────────────────────── */}
        <div style={{ display: 'flex', padding: '0 32px', borderBottom: `1px solid ${S.borderLight}`, background: 'rgba(255,255,255,0.6)', flexShrink: 0 }}>
          {TABS.map(t => (
            <button
              key={t.id}
              onClick={() => setActiveTab(t.id)}
              style={{
                padding: '12px 20px',
                fontSize: 13,
                fontWeight: activeTab === t.id ? 600 : 500,
                color: activeTab === t.id ? S.burgundy : S.textMuted,
                background: 'none',
                border: 'none',
                borderBottom: activeTab === t.id ? `2px solid ${S.burgundy}` : '2px solid transparent',
                cursor: 'pointer',
                transition: 'all 0.15s',
              }}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '24px 32px' }}>
          {/* ── OVERVIEW tab ──────────────────────────────── */}
          {activeTab === 'overview' && <OverviewTab carrier={carrier} />}

          {/* ── BORDEREAUX tab ──────────────────────────────
              Reachable only while the tenant's `bordereaux` feature is on —
              useCarrierDetailFunctions drops both bordereaux tabs from TABS
              and resets activeTab when it is off. */}
          {activeTab === 'bordereaux' && (
            <BordereauxTab
              carrier={carrier}
              bordereaux={bordereaux}
              loadingB={loadingB}
              generating={generating}
              genForm={genForm}
              setGenForm={setGenForm}
              showGenForm={showGenForm}
              setShowGenForm={setShowGenForm}
              sending={sending}
              handleGenerate={handleGenerate}
              handleDownload={handleDownload}
              handleSend={handleSend}
            />
          )}

          {/* ── CONFIGURATION tab ─────────────────────────── */}
          {activeTab === 'config' && (
            <ConfigTab carrier={carrier} config={config} setConfig={setConfig} savingCfg={savingCfg} cfgSaved={cfgSaved} handleSaveConfig={handleSaveConfig} />
          )}
        </div>
      </div>
    </AppLayout>
  );
};

export default CarrierDetail;
